var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_88852",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2027 0.685547H0.639648V20.2605H34.2027V0.685547Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_88852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2027 0.685547H0.639648V20.2605H34.2027V0.685547Z",
    fill: "#BA0019"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_88852",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2027 0.685547H0.639648V20.2605H34.2027V0.685547Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_88852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0142 0.685547H11.8262V20.2605H23.0142V0.685547Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeru);
export default __webpack_public_path__ + "static/media/Peru.73eed462399a4a3c4b11378aa66a82c2.svg";
export { ForwardRef as ReactComponent };